import React, { useState } from 'react';
import './FrontierEdge.css';

function FrontierEdge() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  return (
      <div className="frontier-edge">
        {/* Introduction/Overview Section */}
        <section className="frontier-edge-overview">
          <div className="frontier-edge-header">
            <h1>Federal Frontier FleetEdge</h1>
            <p>
              Powering Kubernetes, Simplified: Our Federal Frontier software, utilizing the versatile Kubernetes Cluster API (CAPI),
              reshapes how you deploy Kubernetes stacks. Especially for the optionally rugged NXP Layerscape-based Frontier
              FleetEdge ARM64 FFE-6S-R node, we ensure a streamlined, replicable, and scalable solution. Single-points-of-failure
              in your hardware and software are simply avoided.
            </p>
          </div>
          <div className="frontier-edge-image-logo">
            <img src="/images/ff_edge_big_2_transparent.png" alt="Frontier Edge Product" />
          </div>
        </section>

        {/* Detailed Explanation and Image */}
        <div className="frontier-edge-detailed-section">
          <div className="frontier-edge-explanation">
            <h2>FleetEdge</h2>
            <p>
              FleetEdge is a cutting-edge deployment solution, specifically designed for streamlining the deployment of Kubernetes
              workload clusters on the edge. This powerful software leverages the Kubernetes Cluster API (CAPI) to revolutionize
              the way organizations deploy Kubernetes in normal and harsh environments. FleetEdge is especially tailored to provide
              a seamless and scalable deployment experience.
            </p>
          </div>
          {/*<div className="frontier-edge-image">*/}
          {/*  <img*/}
          {/*      src="/images/fleetEdgeArchitecture.png"*/}
          {/*      alt="FKG Kubernetes Grid"*/}
          {/*      onClick={openModal}*/}
          {/*  />*/}
          {/*</div>*/}
        </div>
        {isModalOpen && (
            <div className="modal-overlay" onClick={closeModal}>
              <div className="modal">
                <img
                    src="/images/ff-diagram.png"
                    alt="FKG Kubernetes Grid"
                    className="modal-image"
                />
              </div>
            </div>
        )}

        {/* Benefits Section */}
        <div className="frontier-edge-benefits-section">
          <h2>Benefits</h2>
          <div className="frontier-edge-benefits-list">
            <div className="benefit-icon">
              <img src="/images/shield-art.png" alt="Benefit 1" />
              <h3>Enhanced Security and Compliance</h3>
              <p>
                FleetEdge automates security measures and ensures compliance with government standards, making your deployments
                more secure and reducing the risk of vulnerabilities.
              </p>
            </div>
            <div className="benefit-icon">
              <img src="/images/lock-art.png" alt="Benefit 2" />
              <h3>Simplified Management and Maintenance</h3>
              <p>
                With FleetEdge, managing Kubernetes clusters becomes straightforward, and it offers long-term support, reducing
                the complexity of ongoing maintenance and keeping your clusters secure and up-to-date.
              </p>
            </div>
            <div className="benefit-icon">
              <img src="/images/revenue-art.png" alt="Benefit 3" />
              <h3>Efficiency and Scalability</h3>
              <p>
                FleetEdge simplifies the setup of Kubernetes clusters, saving time and effort. It can quickly adapt to different
                environments, making it easy to scale as your needs grow.
              </p>
            </div>
          </div>
        </div>

        {/* How It Works Section (from Word document) */}
        <div className="frontier-edge-how-it-works">
          <h1>Unparalleled Plug-N-Play Deployment</h1>
          <div className="frontier-edge-how-it-works-content">
            <div className="frontier-edge-how-it-works-step">
              <h2>Initial Setup</h2>
              <p>Effortlessly get started with a pre-checked environment that’s ready to run in no time.</p>
            </div>
            <div className="frontier-edge-how-it-works-step">
              <h2>Quick Kubernetes Bootstrapping</h2>
              <p>
                Use the Federal Frontier suite—GUI, CLI, or our comprehensive Plug-N-Play ArgoCD pipeline—to spin up and
                customize your Kubernetes deployment. Once ready, leave the rollout to us!
              </p>
            </div>
            <div className="frontier-edge-how-it-works-step">
              <h2>Software Provisioning</h2>
              <p>
                From lightweight Kubernetes distributions like K3s or MicroK8s to essential add-ons such as Ceph, Calico, or
                Linkerd—Federal Frontier automates everything, including compliance-driven requirements for federal environments.
              </p>
            </div>
            <div className="frontier-edge-how-it-works-step">
              <h2>Network Excellence</h2>
              <p>
                Experience top-tier network isolation and micro-segmentation for diverse single-tenant or multi-tenant workloads,
                powered by Calico Enterprise and Netris.
              </p>
            </div>
            <div className="frontier-edge-how-it-works-step">
              <h2>Monitor, Manage, Secure</h2>
              <p>
                Grafana dashboards provide real-time application insights, while the FIPS-140-2 compliant IPsec VPN or Netris
                Site-Mesh secures your communications back to a centralized location. Stay in control, always!
              </p>
            </div>
            <div className="frontier-edge-how-it-works-step">
              <h2>Remote Connectivity Perfected</h2>
              <p>
                Whether on-premises or cloud-based, our Netris agent software with BGP-enabled routing guarantees smooth
                connectivity as you open up virtualized networks across your enterprise—from the cloud to the data center to
                the edge.
              </p>
            </div>
            <div className="frontier-edge-how-it-works-step">
              <h2>Life-cycle Maintenance Made Easy</h2>
              <p>
                With Federal Frontier’s automated systems, managing Kubernetes cluster lifecycles becomes vastly simplified.
                Security updates? We’ve got you covered—with long-term support, DoD STIG alignment, and CIS benchmarks built in.
              </p>
            </div>
          </div>
        </div>

        {/* Hardware Configurations Section */}


        {/* Learn More Section */}
        <div className="learn-more">
          <a
              href="http://readthedocs.eupraxia.io/docs/frontier-kubernetes-platform/frontier-kubernetes-platform/"
              className="FE-learn-more-button"
              target="_blank"
              rel="noopener noreferrer"
          >
            Learn More
          </a>
          <a href="/images/datasheet.pdf" target="_blank" className="FE-learn-more-button">
            View Datasheet
          </a>
          <a href="/contact" className="FE-learn-more-button">
            Request a Demo
          </a>
          <a href="/contact" className="FE-learn-more-button">
            Contact us for a Quote
          </a>
        </div>
      </div>
  );
}

export default FrontierEdge;